import {useCallback, useState} from 'react';
import {Platform} from 'react-native';
import {useFocusEffect} from '@react-navigation/native';

import apiService from '../../transport/apiService';

import {getWeb3DsBrowserData} from './util/threeDS';

const useFetchMobileWebView3dsBrowserDataJSFocusEffect = () => {
  const browserDataInitialState = Platform.select({
    web: getWeb3DsBrowserData(),
    native: {},
  });

  const [browserData, setBrowserData] = useState(browserDataInitialState);
  const [mobileWebView3DsBrowserDataJS, setMobileWebView3DsBrowserDataJS] =
    useState('');

  useFocusEffect(
    useCallback(() => {
      async function fetchMobileWebView3DsBrowserDataJS() {
        const js = (await apiService.getBrowserDataJs()) as unknown as string;
        setMobileWebView3DsBrowserDataJS(js);
      }
      if (Platform.OS !== 'web') {
        fetchMobileWebView3DsBrowserDataJS();
      }
    }, []),
  );

  return {mobileWebView3DsBrowserDataJS, browserData, setBrowserData};
};

export default useFetchMobileWebView3dsBrowserDataJSFocusEffect;
